import React, { Component } from "react";
import AjaxPost from "../../components/AjaxPost/AjaxPost";
import ThankYou from "../../components/ThankYou/ThankYou";
import GA from "../../components/GA/GA";
import SmoothEvent from "../../components/SmoothAnalytics/";
import Captcha2026 from "../../components/Captcha2026/Captcha2026";
import "./Careers.css";

class Careers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      website: "", // honeypot field — real users never fill this
      postcode: "",
      about: "",
      file: "",
      fileData: "",
      humanCheck: false,
      formOK: false,
      showThankYou: false,
      apiTimestamp: null,
      apiTimestampLoaded: null,
    };
  }

  componentDidMount(props) {
    this.props.changePage("careers");
    GA("Page: Careers");
    SmoothEvent("pageload");

    fetch("/api/ts")
      .then((response) => response.json())
      .then((data) => this.setState({ apiTimestampLoaded: data.ts }))
      .catch(() => this.setState({ apiTimestampLoaded: null }));
  }

  checkFormFields = () => {
    let state = this.state;
    if (
      state.name !== "" &&
      state.email !== "" &&
      state.postcode !== "" &&
      state.about !== "" &&
      state.humanCheck === true
    ) {
      state.formOK = true;
    } else {
      state.formOK = false;
    }
    this.setState(state);
  };

  setValue = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
    this.checkFormFields();
  };

  setFile = (e) => {
    // console.dir( e.target.files[0] )
    let state = this.state;
    state.file = e.target.value;
    state.fileData = e.target.files[0];
    this.setState(state);
    this.checkFormFields();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let that = this;
    let formData = new FormData();

    formData.append("cvFile", this.state.fileData);
    formData.append("name", this.state.name);
    formData.append("email", this.state.email);
    formData.append("postcode", this.state.postcode);
    formData.append("about", this.state.about);
    formData.append("website", this.state.website);
    formData.append("ats", this.state.apiTimestamp);

    AjaxPost("/api/careers", formData, function (e) {
      that.showThankYouMessage();
      GA("Form Submit: Careers");
    });
  };

  showThankYouMessage = (e) => {
    let state = {
      showThankYou: true,
    };
    this.setState(state);
  };

  clearFormValues = (e) => {
    let cleanState = {
      name: "",
      email: "",
      postcode: "",
      about: "",
      file: "",
      fileData: "",
      formOK: false,
    };
    this.setState(cleanState);
  };

  closeThankYou = (e) => {
    let state = this.state;
    state.showThankYou = false;
    this.setState(state);
  };

  handleCaptchaActivated = (e) => {
    let state = this.state;
    state.humanCheck = true;
    state.apiTimestamp = state.apiTimestampLoaded;
    this.setState(state);
    this.checkFormFields();
  }

  render() {
    return (
      <div className="page-container">
        <div className="content-spacer-1 spacer-bg-careers"></div>

        <div className="content-container">
          <div className="content-container-background"></div>

          <div className="content-container-content">
            <h1>Careers</h1>
            <br />
            Are you a friendly, motivated person who enjoys cleaning and always takes pride in their work? We’d love to
            hear from you!
            <br />
            <br />
            Join our team to provide the highest quality service to our customers in London.
            <br />
            <br />
            Choose your own hours & holidays, keep your regular customers & houses, self-employed, with part-time or
            full-time.
            <br />
            <br />
            <form onSubmit={this.handleSubmit} encType="multipart/form-data">
              <div className="floater">
                <span className="form-label">
                  Name <span className="red">*</span>
                </span>
                <br />
                <input
                  type="text"
                  name="name"
                  value={this.state.name}
                  onChange={this.setValue}
                  placeholder="Name"
                  className="form-input"
                />
                <br />
              </div>

              <div className="breaker"></div>

              <div className="floater careers-postcode">
                <span className="form-label">
                  Postcode <span className="red">*</span>
                </span>
                <br />
                <input
                  type="text"
                  name="postcode"
                  value={this.state.postcode}
                  onChange={this.setValue}
                  placeholder="Postcode"
                  className="form-input careers-postcode"
                />
                <br />
              </div>

              <div className="floater careers-email">
                <span className="form-label">
                  Email <span className="red">*</span>
                </span>
                <br />
                <input
                  type="email"
                  name="email"
                  value={this.state.email}
                  onChange={this.setValue}
                  placeholder="Email"
                  className="form-input careers-email"
                />
                <br />
              </div>

              <div className="breaker"></div>

              <div className="floater">
                <span className="form-label">
                  About Yourself <span className="red">*</span>
                </span>
                <br />
                <textarea
                  name="about"
                  value={this.state.about}
                  onChange={this.setValue}
                  className="form-input form-textarea"
                ></textarea>
                <br />
              </div>

              <div className="breaker"></div>

              <div className="floater">
                <span className="form-label">Attach your CV (optional)</span>
                <br />
                <input type="file" name="file" value={this.state.file} onChange={this.setFile} />
                <br />
              </div>

              <input
                type="text"
                name="website"
                value={this.state.website}
                onChange={this.setValue}
                autoComplete="off"
                className="form-input form-input-2"
              />

              <div className="breaker"></div>

              <Captcha2026 onActivate={this.handleCaptchaActivated} />

              <div className={this.state.formOK ? "form-info-hidden" : "form-info"}>
                Please fill in all form fields.
              </div>

              <button disabled={!this.state.formOK} className="form-input form-button">
                Submit
              </button>
            </form>
            <div className={this.state.showThankYou ? "fixed100" : "hidden"}>
              <ThankYou onClick={() => this.closeThankYou()} />
            </div>
            <br />
            <br />
            <div className="cleaning-tips-container">
              <div className="cleaning-tip-icon"></div>
              <i>
                Vinegar is very useful for windows or mirrors, diluted with water your window and mirrors will be
                sparkling clean.
              </i>
              <div className="breaker"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Careers;
